import { Box, styled } from "@mui/material";

export const MenuWrapper = styled(Box)<{ open: boolean }>(({ open }) => {
    return {
        display: open ? "block" : "none",
        "& ul": {
            marginBlockEnd: 0,
            marginInline: 0,
            paddingInline: "56px 0",
            display: "flex",
            flexDirection: "column",
            gap: "calc(var(--flex-gap)/4)",
        },
        "& li": {
            fontFamily: "Inter",
            fontWeight: 700,
            fontSize: "20px",
            lineHeight: "normal",
            color: "#FAF6F6",
            textWrap: "wrap",
            display: "block",
            minHeight: "unset",
            borderRadius: "5px",
            padding: "1rem",
        },
        "& li:hover": {
            color: "#791377",
            backgroundColor: "#FFFFFF",
        },
        "& form": {
            display: "flex",
            flexDirection: "column",
            "& .MuiFormLabel-root": {
                display: "flex",
                gap: "var(--flex-gap)",
                alignItems: "center",
                borderTop: "1px solid #948E8E",
                marginBlock: 0,
                padding: "var(--basic-padding)",
                cursor: "pointer",
            },
            "& .MuiInputBase-root": {
                border: "none",
                padding: 0,
                cursor: "pointer"
            }
        }
    }
})